import { render } from "./drawer-advance-detail.vue?vue&type=template&id=c74e7186&scoped=true"
import script from "./drawer-advance-detail.vue?vue&type=script&lang=js"
export * from "./drawer-advance-detail.vue?vue&type=script&lang=js"

import "./drawer-advance-detail.vue?vue&type=style&index=0&id=c74e7186&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74e7186"]])

export default __exports__